import React from 'react';
import PropTypes from 'prop-types';
import { Button, Typography } from '..';

const CookieDisabledModal = ({ isOpen }) => {
  if (!isOpen) {
    return null;
  }

  const WarningIcon = () => (
    <svg className="w-16 h-16 text-yellow-500 mx-auto mb-5" fill="currentColor" viewBox="0 0 20 20">
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M8.257 3.099c.763-1.36 2.723-1.36 3.486 0l5.58 9.92c.763 1.36-.217 3.031-1.743 3.031H4.42c-1.526 0-2.506-1.671-1.743-3.031l5.58-9.92zM10 13a1 1 0 110-2 1 1 0 010 2zm-1-4 a1 1 0 011-1h.01a1 1 0 110 2H10a1 1 0 01-1-1z"
      />
    </svg>
  );

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-6 sm:p-8 rounded-xl shadow-2xl text-center max-w-md mx-4">
        <WarningIcon />
        <Typography
          variant="h2"
          text="Cookies Disabled"
          className="text-2xl font-bold text-gray-800 mb-2"
        />
        <Typography
          variant="p-lg"
          text="To ensure this website functions correctly, please enable cookies in your browser settings. Once enabled, please reload this page."
          className="text-gray-600 mb-8 leading-relaxed"
        />
        <div className="mt-8">
          <Button onClick={() => window.location.reload()} size="lg" className="w-full h-12">
            Reload Page
          </Button>
        </div>
      </div>
    </div>
  );
};

CookieDisabledModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
};

export default CookieDisabledModal;
